module.exports = __webpack_public_path__ + "static/Drink-420f6766b525f6e41423786fd9095716.png";